import { FilterTagsCondition } from 'dashboard/components/TagsConditionFilter';
import { ReportFilterCondition } from 'dashboard/lib/reports/filterMetas';
import { GraphExportCluster } from 'dashboard/models/graph';
import { CheckFilterValues } from 'dashboard/redux/actions/inquiries';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum ExporterStatus {
  Pending = 'pending',
  Ready = 'ready',
  Errored = 'errored',
  Canceled = 'canceled',
  Archived = 'archived',
}

export enum ExporterFileType {
  TarGz = 'tar.gz',
  Zip = 'zip',
}

export interface ExporterAttributes {
  status?: ExporterStatus;
  data?: {
    [key: string]: undefined | string | string[];
  };
  filter?: {
    [key: string]:
      | undefined
      | string
      | string[]
      | CheckFilterValues[]
      | FilterTagsCondition[][]
      | ReportFilterCondition[][];
  };
  sort?: string;
  'export-data'?: GraphExportCluster[];
  filename?: string;
  'file-download-url'?: string;
  'created-at'?: string;
  'completed-at'?: string;
  'archived-at'?: string;
  'file-type'?: ExporterFileType;
}

export interface ExporterInquiryAttributes extends ExporterAttributes {}

export type ExporterInquiry = ApiResource<
  ExporterInquiryAttributes,
  ExporterRelationships,
  ApiModel.ExporterInquiry
>;

export interface ExporterMetricsVerificationVolumeAttributes extends ExporterAttributes {}

export type ExporterMetricsVerificationVolume = ApiResource<
  ExporterMetricsVerificationVolumeAttributes,
  ExporterRelationships,
  ApiModel.ExporterMetricsVerificationVolume
>;

export interface ExporterMetricsInquiryAttributes extends ExporterAttributes {}

export type ExporterMetricsInquiry = ApiResource<
  ExporterMetricsInquiryAttributes,
  ExporterRelationships,
  ApiModel.ExporterMetricsInquiry
>;

export interface ExporterMetricsVerificationChecksAttributes extends ExporterAttributes {}

export type ExporterMetricsVerificationChecks = ApiResource<
  ExporterMetricsVerificationChecksAttributes,
  ExporterRelationships,
  ApiModel.ExporterMetricsVerificationChecks
>;

export interface ExporterAccountAttributes extends ExporterAttributes {}

export type ExporterAccount = ApiResource<
  ExporterAccountAttributes,
  ExporterRelationships,
  ApiModel.ExporterAccount
>;

export interface ExporterReviewQueueTaskAttributes extends ExporterAttributes {}

export type ExporterReviewQueueTask = ApiResource<
  ExporterReviewQueueTaskAttributes,
  ExporterRelationships,
  ApiModel.ExporterReviewQueueTask
>;

export interface ExporterCaseAttributes extends ExporterAttributes {}

export type ExporterCase = ApiResource<
  ExporterCaseAttributes,
  ExporterRelationships,
  ApiModel.ExporterCase
>;

export interface ExporterGraphAttributes extends ExporterAttributes {}

export type ExporterGraph = ApiResource<
  ExporterGraphAttributes,
  ExporterRelationships,
  ApiModel.ExporterGraph
>;

export interface ExporterReportAttributes extends ExporterAttributes {}

export type ExporterReport = ApiResource<
  ExporterReportAttributes,
  ExporterRelationships,
  ApiModel.ExporterReport
>;

export interface ExporterTransactionAttributes extends ExporterAttributes {}

export type ExporterTransaction = ApiResource<
  ExporterTransactionAttributes,
  ExporterRelationships,
  ApiModel.ExporterTransaction
>;

export interface ExporterDatasetAttributes extends ExporterAttributes {}

export type ExporterDataset = ApiResource<
  ExporterDatasetAttributes,
  ExporterRelationships,
  ApiModel.ExporterDataset
>;

export interface ExporterInsightQueryAttributes extends ExporterAttributes {}

export type ExporterInsightQuery = ApiResource<
  ExporterInsightQueryAttributes,
  ExporterRelationships,
  ApiModel.ExporterInsightQuery
>;

export type ExporterType =
  | ApiModel.ExporterAccount
  | ApiModel.ExporterCase
  | ApiModel.ExporterCustomFile
  | ApiModel.ExporterDataset
  | ApiModel.ExporterGraph
  | ApiModel.ExporterInsightQuery
  | ApiModel.ExporterInquiry
  | ApiModel.ExporterReviewQueueTask
  | ApiModel.ExporterMetricsVerificationVolume
  | ApiModel.ExporterMetricsVerificationChecks
  | ApiModel.ExporterMetricsInquiry
  | ApiModel.ExporterReport
  | ApiModel.ExporterTransaction;

export interface ExporterRelationships {
  user: ApiRelationship<ApiModel.User>;
}

export type Exporter = ApiResource<ExporterAttributes, ExporterRelationships, ExporterType>;
